
export const PRODUCT_ADD_REQUEST = "PRODUCT_ADD_REQUEST";
export const PRODUCT_ADD_SUCCESS = "PRODUCT_ADD_SUCCESS";
export const PRODUCT_ADD_FAILURE = "PRODUCT_ADD_FAILURE";

export const PRODUCT_EDIT_REQUEST = "PRODUCT_EDIT_REQUEST";
export const PRODUCT_EDIT_SUCCESS = "PRODUCT_EDIT_SUCCESS";
export const PRODUCT_EDIT_FAILURE = "PRODUCT_EDIT_FAILURE";

export const PRODUCT_VIEW_REQUEST = "PRODUCT_VIEW_REQUEST";
export const PRODUCT_VIEW_SUCCESS = "PRODUCT_VIEW_SUCCESS";
export const PRODUCT_VIEW_FAILURE = "PRODUCT_VIEW_FAILURE";

export const PRODUCT_VIEW_ALL_REQUEST = "PRODUCT_VIEW_ALL_REQUEST";
export const PRODUCT_VIEW_ALL_SUCCESS = "PRODUCT_VIEW_ALL_SUCCESS";
export const PRODUCT_VIEW_ALL_FAILURE = "PRODUCT_VIEW_ALL_FAILURE";

export const PRODUCT_VIEW_BY_BRAND_ID_REQUEST = "PRODUCT_VIEW_BY_BRAND_ID_REQUEST";
export const PRODUCT_VIEW_BY_BRAND_ID_SUCCESS = "PRODUCT_VIEW_BY_BRAND_ID_SUCCESS";
export const PRODUCT_VIEW_BY_BRAND_ID_FAILURE = "PRODUCT_VIEW_BY_BRAND_ID_FAILURE";

export const PRODUCT_SEARCH_REQUEST = "PRODUCT_SEARCH_REQUEST";
export const PRODUCT_SEARCH_SUCCESS = "PRODUCT_SEARCH_SUCCESS";
export const PRODUCT_SEARCH_FAILURE = "PRODUCT_SEARCH_FAILURE";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAILURE = "PRODUCT_DELETE_FAILURE";

export const PRODUCT_RESET_STATE = "PRODUCT_RESET_STATE";
